import { Stack, TextField } from '@mui/material';
import React from 'react';

import { FieldEditorSection } from '../types/FieldEditorSection';
import { InputArea } from './InputArea';

export function UIAdornmentsSettings({ field, setField }: FieldEditorSection) {
  return (
    <Stack
      direction="row"
      gap={2}
      sx={{
        '& > *': {
          flexGrow: 1,
        },
      }}
    >
      <InputArea
        name="UI Starting Adornment"
        description="The adornment to display at the start of the field"
      >
        <TextField
          size="small"
          label="Text"
          value={field.ui?.adornments?.start?.text}
          onChange={(e) =>
            setField({
              ...field,
              ui: {
                ...field.ui,
                adornments: {
                  ...field.ui?.adornments,
                  start: {
                    ...field.ui?.adornments?.start,
                    text: e.target.value,
                  },
                },
              },
            })
          }
        />
        <TextField
          size="small"
          label="Icon"
          value={field.ui?.adornments?.start?.icon}
          onChange={(e) =>
            setField({
              ...field,
              ui: {
                ...field.ui,
                adornments: {
                  ...field.ui?.adornments,
                  start: {
                    ...field.ui?.adornments?.start,
                    icon: e.target.value,
                  },
                },
              },
            })
          }
        />
        <TextField
          size="small"
          label="Color"
          value={field.ui?.adornments?.start?.color}
          onChange={(e) =>
            setField({
              ...field,
              ui: {
                ...field.ui,
                adornments: {
                  ...field.ui?.adornments,
                  start: {
                    ...field.ui?.adornments?.start,
                    color: e.target.value,
                  },
                },
              },
            })
          }
        />
      </InputArea>
      <InputArea
        name="UI Ending Adornment"
        description="The adornment to display at the start of the field"
      >
        <TextField
          size="small"
          label="Text"
          value={field.ui?.adornments?.end?.text}
          onChange={(e) =>
            setField({
              ...field,
              ui: {
                ...field.ui,
                adornments: {
                  ...field.ui?.adornments,
                  end: {
                    ...field.ui?.adornments?.end,
                    text: e.target.value,
                  },
                },
              },
            })
          }
        />
        <TextField
          size="small"
          label="Icon"
          value={field.ui?.adornments?.end?.icon}
          onChange={(e) =>
            setField({
              ...field,
              ui: {
                ...field.ui,
                adornments: {
                  ...field.ui?.adornments,
                  end: {
                    ...field.ui?.adornments?.end,
                    icon: e.target.value,
                  },
                },
              },
            })
          }
        />
        <TextField
          size="small"
          label="Color"
          value={field.ui?.adornments?.end?.color}
          onChange={(e) =>
            setField({
              ...field,
              ui: {
                ...field.ui,
                adornments: {
                  ...field.ui?.adornments,
                  end: {
                    ...field.ui?.adornments?.end,
                    color: e.target.value,
                  },
                },
              },
            })
          }
        />
      </InputArea>
    </Stack>
  );
}
